if (!customElements.get('collapsible-description')) {
  customElements.define(
    'collapsible-description',
    class CollapsibleDescription extends HTMLElement {
      // Collapsed view shows ~10% of the full description height, but never
      // less than MIN_COLLAPSED_PX so short screens still get a readable teaser.
      static COLLAPSED_RATIO = 0.1;
      static MIN_COLLAPSED_PX = 120;
      // If expanding would only reveal less than this, skip collapsing entirely.
      static MIN_HIDDEN_PX = 80;

      connectedCallback() {
        this.content = this.querySelector('.collapsible-description__content');
        this.toggle = this.querySelector('.collapsible-description__toggle');
        if (!this.content || !this.toggle) return;

        this.expanded = false;
        this.toggle.addEventListener('click', this.onToggle.bind(this));

        this.measure = this.measure.bind(this);
        requestAnimationFrame(this.measure);
        // Re-measure once images inside the description have loaded and on resize.
        window.addEventListener('load', this.measure);
        this.resizeTimer = null;
        window.addEventListener('resize', () => {
          clearTimeout(this.resizeTimer);
          this.resizeTimer = setTimeout(this.measure, 150);
        });
      }

      measure() {
        const previousMaxHeight = this.content.style.maxHeight;
        this.content.style.maxHeight = 'none';
        const fullHeight = this.content.scrollHeight;
        this.content.style.maxHeight = previousMaxHeight;

        const ctor = this.constructor;
        this.collapsedHeight = Math.max(
          Math.round(fullHeight * ctor.COLLAPSED_RATIO),
          ctor.MIN_COLLAPSED_PX
        );

        if (fullHeight - this.collapsedHeight < ctor.MIN_HIDDEN_PX) {
          this.toggle.hidden = true;
          this.classList.remove('is-collapsed');
          this.content.style.maxHeight = '';
          return;
        }

        this.toggle.hidden = false;
        if (this.expanded) {
          this.content.style.maxHeight = `${fullHeight}px`;
        } else {
          this.classList.add('is-collapsed');
          this.content.style.maxHeight = `${this.collapsedHeight}px`;
        }
      }

      onToggle() {
        this.expanded = !this.expanded;
        this.toggle.setAttribute('aria-expanded', this.expanded ? 'true' : 'false');

        if (this.expanded) {
          this.classList.remove('is-collapsed');
          this.content.style.maxHeight = `${this.content.scrollHeight}px`;
        } else {
          this.classList.add('is-collapsed');
          this.content.style.maxHeight = `${this.collapsedHeight}px`;
          // Keep the collapsed description in view so the page doesn't appear to jump.
          this.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    }
  );
}
